module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-02-23 at 22.49.29 (20).f356a0ab.jpeg";